angular.module('mtic')
.constant('ASSET_HOST', {
  "CONTAINER": {
    "openfl": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/openfl/index.html",
      "VERSION": "7Ga7bZ9dYkLbNpCcvAK_1vt9EyXk1fr1"
    },
    "openfl_c4": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/c4html5/index.html",
      "VERSION": "e1qG8.vCoVt8L6sh_ZGS7cfQolJTwDoD"
    },
    "html_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/items/packages"
    },
    "inbook_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/inbook/router/index.html",
      "VERSION": "RxmtIgogM4K7MgcB0thinZ1LVKYMV6Hc"
    },
    "c4swf": {
      "URL" : "https://mtic-items.s3.amazonaws.com/containers/c4swf/v18/index.html",
      "VERSION":"cQmB5r5dbuyBzP3E_Hq6382E0g2yogB0"
    },
    "itematic_package": {
      "URL": "https://d3kdl9636cazwt.cloudfront.net/containers/itematic/",
      // "URL": "http://localhost:3002/",
      "VERSION": "v1.1.18"
    }
  },
  "IMAGE": {
    "star": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fstar.png%2F1504458986485_93014%2Fstar.png?alt=media&token=3e72a373-3eb9-497d-842b-8b682d45d643",
    "star-empty": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fstar-empty.png%2F1504458955264_98267%2Fstar-empty.png?alt=media&token=9747daba-cd5b-4a3f-9a46-0b31c9a22070",
    "ribbon-a": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-a.png%2F1504458542000_48773%2Fribbon-a.png?alt=media&token=61b6fbb3-8d3f-4579-8903-3006a70bd532",
    "ribbon-b": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-b.png%2F1504458529694_98701%2Fribbon-b.png?alt=media&token=3c839792-d3c1-42a7-b08e-3b29c2fbe3c8",
    "ribbon-c": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fribbon-c.png%2F1504458457725_99417%2Fribbon-c.png?alt=media&token=ad1663f9-7ec4-417a-bd03-9fb54147665b",
    "replay-icon": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Freplay-icon.png%2F1504458610787_27303%2Freplay-icon.png?alt=media&token=b244ed55-5684-4806-9090-49ff9b339a28",
    "continue-icon": "https://firebasestorage.googleapis.com/v0/b/mathematicmaker.appspot.com/o/item_authoring%2Fcontinue-icon.png%2F1504458623591_45219%2Fcontinue-icon.png?alt=media&token=0c65be65-e6d8-45f1-b1d5-c959460235f1",
  }
})
